import Ajax from "Utils/ajax";
export const expenseClaimNotPaid = (data) => Ajax.post('account/expenseClaimNotPaid',data); 
export const getClaimCategory = (data) => Ajax.post('account/claimCategory',data); 